<template>
  <v-app>
    <v-main>
      <v-app-bar id="app-bar" color="#0d0d0d" dark compact>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Help Centre</v-toolbar-title>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" absolute>
        <v-list dense>
          <v-list-group
            v-for="catagory in categories"
            :key="catagory.id"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon class="catagory-icon" v-text="catagory.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="catagory.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              @click.stop="drawer = !drawer"
              :href="getAnchorUrl(catagory.url, article)"
              v-for="article in getCategoryArticles(catagory)"
              :key="article.id"
            >
              <v-list-item-content>
                <v-list-item-title v-text="article.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
      <v-container id="container" class="d-flex">
        <v-list id="nav-container">
          <help-centre-nav-item
            v-for="category in this.categories"
            :key="category.id"
            :category="category"
            :expanded="navItemIsExpanded(category)"
            :articles="getCategoryArticles(category)"
          />
        </v-list>
        <div id="articles-container">
          <v-icon class="icon" v-text="getIcon()"></v-icon>
          <!-- <div><a href="/help">Uni-Truths Help Centre</a> > {{this.category}}</div>  -->
          <div class="h1">{{ this.category }}</div>
          <div
            v-for="article in this.currentArticles"
            :key="article.id"
            class="article-container pt-2"
          >
            <div :id="article.slug" class="article">
              {{ article.title }}
              <a class="blue--text" :href="'#' + article.slug">#</a>
            </div>
            <vue-markdown class="article-text pt-1">{{
              article.text
            }}</vue-markdown>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import helpCentreNavItem from './helpCentreNavItem';
import VueMarkdown from 'vue-markdown';

export default {
  components: { helpCentreNavItem, VueMarkdown },
  props: {
    categories: Array,
    category: String,
    articles: Array,
    currentArticles: Array
  },
  data: () => ({
    drawer: false,
    group: null
  }),
  watch: {
    group() {
      this.drawer = false;
    }
  },
  methods: {
    getAnchorUrl(catagory, article) {
      return catagory + '#' + article.slug;
    },
    getIcon() {
      return this.categories.filter(x => x['title'] === this.category)[0][
        'icon'
      ];
    },
    getCategoryArticles(c) {
      return this.articles.filter(a => a.category === c.title);
    },
    navItemIsExpanded(category) {
      return this.category === category.title;
    }
  }
};
</script>
<style scoped>
.container {
  margin: 0;
  max-width: 100%;
}
#content {
  padding: 0;
}
.article {
  font-size: 175%;
  border-bottom: 1px solid #c4c4c4;
}
.article-text {
  width: 100%;
}
#nav-container {
  background-color: #f7faff !important;
  width: 25rem;
}
#articles-container {
  margin-top: 2rem;
  width: 90%;
}
.icon {
  font-size: 8rem !important;
  color: rgb(80, 120, 216, 0.85) !important;
  margin-bottom: 2rem;
  margin-right: 1rem;
}
.article-container {
  margin-right: 2.5rem;
}
.article-container a {
  color: blue !important;
}
.v-list-item__icon {
  max-width: 24px;
}
.catagory-icon {
  color: rgb(80, 120, 216, 0.85) !important;
}
@media (orientation: portrait) {
  #catagory-list {
    display: none;
  }
  #nav-container {
    display: none;
  }
  #articles-container {
    margin-top: 2rem;
    width: 100%;
    margin-left: 20px;
  }
  .article-container {
    margin-right: 20px;
  }
}
@media (orientation: landscape) {
  #app-bar {
    display: none;
  }
}
</style>
